import React, { useEffect, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Underline } from '../svg';

export type UnderlineBowProps = {
    children: React.ReactNode;
    bottom
}

const UnderlineBowStyled = styled(({ bottom, ...rest }) => <div {...rest} />)<UnderlineBowProps>`
  font-weight: 600;
  display: inline-block;
  position: relative;

  svg {
    position: absolute;
    width: 105%;
    bottom: ${({ bottom }) => bottom}px;
    right: -2px;
  }
`;

const UnderlineBow = (props: UnderlineBowProps): JSX.Element => {
    const ref = useRef<HTMLDivElement>();
    const [bottom, setBottom] = useState<number>(-2);
    useEffect(() => {
        const relation = ref.current.clientWidth / ref.current.clientHeight;
        if (relation > 2.8) setBottom(-5);
        if (relation > 4) setBottom(-10);
    }, []);

    return <span ref={ref}>
        <UnderlineBowStyled bottom={bottom}>
            {props.children}
            <Underline />
        </UnderlineBowStyled>
    </span>;
};

export default UnderlineBow;
